import store from '@/store'

import {
  getUrlParm
} from '@/cllib/tools'

import {
  saveData,
  getData
} from '@/cllib/local_storage'

const dealUrl = () => {
  let url = window.location.href
  if (url.split('#').length > 1) {
    let urlJ = url.split('#')[0]
    if (urlJ.includes('?')) {
      let newUrl = ''
      let newUrl1 = urlJ.split('?')[0]
      let urlJparm = urlJ.split('?')[1]
      let newUrl2 = url.split('#')[1]
      newUrl = newUrl1 + '#' + newUrl2 + '?' + urlJparm
      window.location.href = newUrl
    }
  }
}

const mainInit = () => {
  dealUrl()
  let urlParm = getUrlParm()
  if (urlParm['wx'] === '1') {
    saveData({key: 'isWeiXin', data: '1'})
  } else if (urlParm['wx'] === '0') {
    saveData({key: 'isWeiXin', data: '0'})
  }
  store.dispatch('setIsWeiXinUse', getData('isWeiXin') === '1')
  if (urlParm['code']) {
    store.dispatch('setWeiXinCode', urlParm['code'])
    store.dispatch('setWeiXinGoUrl', window.location.href)
  }
  // if (urlParm['user_code']) {
  //   store.dispatch('setUrlUserCode', urlParm['user_code'])
  // }
  if (urlParm['user_token']) {
    saveData({key: 'token', data: urlParm['user_token']})
  }
  if (urlParm['sys_theme']) {
    store.dispatch('setSysTheme', urlParm['sys_theme'])
  }
  if (urlParm['jmp'] && Number(urlParm['jmp'])) {
    store.dispatch('setJmpData', Number(urlParm['jmp']))
  }
}

export default mainInit



// WEBPACK FOOTER //
// ./src/cllib/app_init.js